import styled, { css, keyframes } from 'styled-components/macro';
import { DSScaledColors } from 'styles';
import { hexToRGB } from 'utils';

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
`;

const rotateAndPulse = keyframes`
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(0.9); }
  100% { transform: rotate(360deg) scale(1); }
`;

const negativeRotateAndPulse = keyframes`
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(-180deg) scale(0.9); }
  100% { transform: rotate(-360deg) scale(1); }
`;

export const Container = styled.div<{
  $color: keyof DSScaledColors;
  $size: string;
  $isBright: boolean;
  $animationSpeed: number;
}>`
  width: ${(props) => props.$size};

  ${({ theme, $color, $isBright, $animationSpeed }) => css`
    position: relative;
    max-width: 80%;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: ${$isBright ? 0.5 : 0.25};
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;

      &:nth-child(1) {
        color: ${theme.colors[$color][$isBright ? 400 : 400]};
        animation-name: ${rotateAndPulse};
        animation-duration: ${20 / $animationSpeed}s;
      }
      &:nth-child(2) {
        color: ${theme.colors[$color][$isBright ? 600 : 500]};
        animation-name: ${negativeRotateAndPulse};
        animation-duration: ${15 / $animationSpeed}s;
      }
      &:nth-child(3) {
        color: ${theme.colors[$color][$isBright ? 700 : 300]};
        animation-name: ${rotateAndPulse};
        animation-duration: ${25 / $animationSpeed}s;
      }
      &:nth-child(4) {
        color: ${theme.colors[$color][$isBright ? 800 : 600]};
        animation-name: ${negativeRotateAndPulse};
        animation-duration: ${17 / $animationSpeed}s;
      }
    }

    .central-circle {
      position: relative;
      z-index: 10;
      width: 90%;
      height: 90%;
      border-radius: 50%;
      background: radial-gradient(
        ${theme.colors[$color][$isBright ? 600 : 700]} 0%,
        ${hexToRGB(
            theme.colors[$color][$isBright ? 500 : 400],
            $isBright ? 0.3 : 0.1
          )}
          85%,
        transparent 91%
      );
      opacity: ${$isBright ? 0.8 : 0.4};
      animation: ${pulse} ${4 / $animationSpeed}s ease-in-out forwards infinite;
    }

    .text-wrapper {
      position: absolute;
      z-index: 11;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${theme.colors.white};
      pointer-events: none;
    }
  `}
`;
